export default class PlatformTokenPair {
    /**
     * @constructor
     * @param {Object} params
     * @param {string} params.accessToken
     * @param {string} params.refreshToken
     * @param {Date} params.expiresAt
     */
    constructor({ accessToken, refreshToken, expiresAt }) {
        this._accessToken = accessToken;
        this._refreshToken = refreshToken;
        this._expiresAt = expiresAt;
    }

    get accessToken() {
        return this._accessToken;
    }

    get refreshToken() {
        return this._refreshToken;
    }

    get expiresAt() {
        return this._expiresAt;
    }

    isExpired() {
        return new Date() >= this._expiresAt;
    }

    expiresIn(milliseconds) {
        const now = new Date();
        const expiresIn = this._expiresAt - now;
        return expiresIn <= milliseconds;
    }
}